import React, { Component } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import routes from './routes'
import { ThemeProvider } from 'emotion-theming'
import theme from './theme'
import { PageWrapper } from 'components/page-wrapper'
import { NavBar } from 'components/nav'
import { ApolloProvider } from 'react-apollo'
import ApolloClient from 'apollo-boost'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createBrowserHistory } from 'history'
import clientData from './utils/client-data'
import productPageRoutes from './product-page-routes'
import { giftGuideRoutes } from './gift-guide-routes'

const basename = (({ requestURI, locality: { country } }) => {
  const countryCode = country === 'GB' ? 'UK' : country
  return `/${countryCode.toLowerCase()}${requestURI}`
})(clientData)

const history = createBrowserHistory({ basename })

const clientState = {
  defaults: {
    selectedDay: '',
    recipientEmail: '',
    sku: '',
    imgUrl: '',
    senderName: '',
    note: '',
    isGifting: true,
    productTermsAndConditions: '',
    productName: '',
    productDescription: '',
    customAmount: {
      currency_code: 'USD',
      value: 0,
    },
    checkedCustomAmount: false,
    onReviewPage: false,
    cartItems: [],
    bundleItems: [],
  },
  resolvers: {},
}

const elmo = clientData.experimentation
const { inContextFlow } = clientData
const productPage = productPageRoutes()
const giftGuides = giftGuideRoutes()

class App extends Component {
  state = {
    client: null,
    loaded: false,
  }

  async componentDidMount() {
    this.init()
    document.body.id = 'gifts-new'
  }

  async init() {
    const cache = new InMemoryCache({ addTypename: false })

    const query = new URLSearchParams(window.location.search).toString()
    const client = new ApolloClient({
      uri: `${basename}/graphql${query ? '?' + query : ''}`,
      headers: {
        'x-csrf-token': clientData.csrf,
      },
      cache,
      clientState,
    })

    this.setState({
      client,
      loaded: true,
    })
  }

  render() {
    const { client, loaded } = this.state

    if (!loaded) {
      return <div>Loading...</div>
    }

    return (
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <Router history={history}>
            <PageWrapper inContextFlow={inContextFlow}>
              {!inContextFlow ? <NavBar /> : null}
              <main>
                <Switch>
                  {routes.map((route, index) => {
                    return (
                      <Route
                        key={`route-${index}`}
                        exact={route.exact}
                        path={route.path}
                        component={route.component}
                      />
                    )
                  })}

                  {productPage}

                  {!!elmo.v2guides && giftGuides}

                  <Redirect to="/" />
                </Switch>
              </main>
            </PageWrapper>
          </Router>
        </ThemeProvider>
      </ApolloProvider>
    )
  }
}

export default App
